import styled from "styled-components";
import { theme } from "../../../styles/themes";
import {
  Form,
  Grid,
  SelectMenu,
  SelectOption,
  TextField,
  Typography,
} from "../../util";
import { GridProps } from "@material-ui/core";
import { buildBoxShadow } from "../../../helpers";

export interface StyledGridProps extends GridProps {
  $fullHeight?: boolean;
}

export const ModalHeaderGrid = styled(Grid)<StyledGridProps>`
  border-bottom: 1px solid ${theme.color.surface.border.default.default};
  padding: 20px 24px;
  margin-bottom: 10px;
`;
export const ModalTitle = styled(Typography)`
  padding: 5px 0px;
`;
export const ModalClientTitle = styled(Typography)`
  padding: 0px;
`;
export const ModalBody = styled(Grid)`
  padding: 24px;
  padding-top: 12px;
  padding-bottom: 0px;
`;
export const ModalBodyTitle = styled(Grid)<StyledGridProps>`
  padding-top: 0px;
  padding-bottom: 25px;
`;

export const ModalForm = styled(Form)`
  & > div:nth-last-child(2) {
    margin-bottom: 48px;
  }
`;

export const ModalTextField = styled(TextField)`
  height: 44px;
`;

export const ModalBodyComponentFooter = styled(Grid)<StyledGridProps>`
  margin-bottom: 25px;
`;

export const ModalFooter = styled.hr`
  position: relative;
  border-bottom: 1px solid ${theme.color.surface.border.weaker.default};
  bottom: 90px;
`;

export const MoreOptionSelectMenu = styled(SelectMenu)`
  transform: translate3d(10px, 10px, 0);
  z-index: 99;
  border-radius: 6px;
  box-shadow: ${buildBoxShadow("high", "default")};
`;

export const MoreOptionSelectOption = styled(SelectOption)`
  padding: 8px 15px;
  background-color: ${theme.color.surface.background.default.default};
`;
